import { render } from "./MultisidebarSaveActions.vue?vue&type=template&id=cf104da2&ts=true"
import script from "./MultisidebarSaveActions.vue?vue&type=script&lang=ts"
export * from "./MultisidebarSaveActions.vue?vue&type=script&lang=ts"

import "./MultisidebarSaveActions.vue?vue&type=style&index=0&id=cf104da2&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__